import type { Entitlement } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { getEntitlements as getEntitlementsQuery } from "@/graphql/queries";
import type { GraphQLError } from "graphql";

const client = generateClient();

export const entitlementsState = create<State<Entitlement[]>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getEntitlementsIsloading = () =>
  entitlementsState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const getEntitlementsIsError = (error: GraphQLError[]) =>
  entitlementsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const getEntitlementsIsSuccess = (entitlements: Entitlement[]) =>
  entitlementsState.setState(() => ({
    data: entitlements,
    isLoading: false,
    error: null,
  }));

export const getEntitlements = async () => {
  getEntitlementsIsloading();

  try {
    const { data } = await client.graphql({
      query: getEntitlementsQuery,
    });

    getEntitlementsIsSuccess(data.getEntitlements as Entitlement[]);
  } catch (e: unknown) {
    const graphQl = e as GraphQLResult<Entitlement[]>;
    getEntitlementsIsError(graphQl.errors as GraphQLError[]);
  }
};
